export default function isHttpStream(url) {
  return /^http:\/\//.test(url);
}
